// Section 16 inequality: a single dial with a tooltip. The needle shows the food Gini (0 equal,
// 0.5 and above very unequal); the value is also written as a number, so meaning never rests on
// colour or position alone. Props only.
import { societyText } from '../text/en';

interface Props {
  food: number;
  beds: number;
  series: readonly number[];
}

const MAX = 0.5;

export function InequalityDial({ food, beds, series }: Props) {
  const t = Math.min(1, Math.max(0, food / MAX));
  // Half-circle from 180deg (left, equal) to 0deg (right, unequal).
  const angle = Math.PI * (1 - t);
  const x = 50 + 38 * Math.cos(angle);
  const y = 50 - 38 * Math.sin(angle);
  const peak = series.length === 0 ? food : Math.max(...series);
  return (
    <figure class="society-dial">
      <svg viewBox="0 0 100 58" role="img" aria-labelledby="society-dial-title">
        <title id="society-dial-title">{societyText.inequalityTitle(food.toFixed(2), MAX)}</title>
        <path d="M 10 50 A 40 40 0 0 1 90 50" class="society-dial__arc" />
        {[0, 0.25, 0.5, 0.75, 1].map((f) => {
          const a = Math.PI * (1 - f);
          return (
            <line
              key={f}
              x1={50 + 36 * Math.cos(a)}
              y1={50 - 36 * Math.sin(a)}
              x2={50 + 42 * Math.cos(a)}
              y2={50 - 42 * Math.sin(a)}
              class="society-dial__tick"
            />
          );
        })}
        <line x1="50" y1="50" x2={x} y2={y} class="society-dial__needle" />
        <circle cx="50" cy="50" r="3" class="society-dial__hub" />
      </svg>
      <figcaption>
        <details class="society-tip">
          <summary aria-label={societyText.inequalityShow(food.toFixed(2))}>
            <span class="num">{food.toFixed(2)}</span> {societyText.inequalityFood}
          </summary>
          <p>{societyText.inequalityHint}</p>
          <table class="society-tip__factors">
            <tbody>
              <tr>
                <th scope="row">{societyText.inequalityFood}</th>
                <td class="num">{food.toFixed(2)}</td>
              </tr>
              <tr>
                <th scope="row">{societyText.inequalityBeds}</th>
                <td class="num">{beds.toFixed(2)}</td>
              </tr>
              <tr>
                <th scope="row">{societyText.inequalityPeak}</th>
                <td class="num">{peak.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </details>
      </figcaption>
    </figure>
  );
}
